// extracted by mini-css-extract-plugin
export default {"root":"U4Q4U9QsgTb82H8rOuMi"};